"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorePieChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CorePieChart = /** @class */ (function (_super) {
    tslib_1.__extends(CorePieChart, _super);
    function CorePieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CorePieChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "pie" }, this.props));
    };
    return CorePieChart;
}(react_1.default.PureComponent));
exports.CorePieChart = CorePieChart;
//# sourceMappingURL=CorePieChart.js.map